import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
import { AgentPaymentHandlerComponent } from './agent-payment.handler';

@Component({
  selector: 'sym-agent-payment',
  templateUrl: './agent-payment.component.html',
  styleUrls: ['./agent-payment.component.scss'],
})
export class AgentPaymentComponent extends AgentPaymentHandlerComponent implements OnInit {
  constructor(agentService: AgentService, settingService: SettingService) {
    super(agentService, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.service.responseIO.data.PaymentList[0]['payeeName'] = this.service.responseIO.data.AgentParty.fullName
      ? this.service.responseIO.data.AgentParty.fullName
      : '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
  }
  public onAddPaymentDetail(event) {
    this.service.addPaymentDetail();
  }
}
